import { render, staticRenderFns } from "./AcademicUnits.vue?vue&type=template&id=e0c675d2"
import script from "./AcademicUnits.vue?vue&type=script&lang=js"
export * from "./AcademicUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports